import { render } from "./ModalFairGame.vue?vue&type=template&id=378900bf&scoped=true"
import script from "./ModalFairGame.vue?vue&type=script&lang=js"
export * from "./ModalFairGame.vue?vue&type=script&lang=js"

import "./ModalFairGame.vue?vue&type=style&index=0&id=378900bf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-378900bf"]])

export default __exports__